import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { IconLabel, IconLabelHintDirection } from '../../../IconLabel';

import classes from './History.module.scss';

interface HistoryProps {
  editor: Editor;
}

export const History: FunctionComponent<HistoryProps> = ({ editor }) => {
  const { canUndo, canRedo } = useEditorState({
    editor,
    selector: ({ editor }) => ({ canUndo: editor.can().undo(), canRedo: editor.can().redo() }),
  });

  return (
    <div className={classes['history']}>
      <IconLabel
        iconId={'undo'}
        iconSize={20}
        onMouseDown={() => editor.chain().undo().run()}
        disabled={!canUndo}
        data={'Undo'}
        hintDirection={IconLabelHintDirection.top}
      />
      <IconLabel
        iconId={'redo'}
        iconSize={20}
        onMouseDown={() => editor.chain().redo().run()}
        disabled={!canRedo}
        data={'Redo'}
        hintDirection={IconLabelHintDirection.top}
      />
    </div>
  );
};
